import {properties as propertiesCloudConfig } from 'config/Config';
/**
 * Constante que contiene un objeto con los textos de la página
 */
 export const objText = {
    titulos: {
        altaUsuario: 'Alta de usuario',
        datosPersonales: 'Datos personales',
        datosEntidadRepresentada: 'Datos entidad representada',
        direccion: 'Dirección',
        direccionInteresado: 'Dirección interesado',
        direccionEntidadRepresentada: 'Dirección entidad representada',
    },
    parrafo: 'Es necesario que crees tu cuenta para que puedas presentar tus solicitudes de forma online.',
    alert: {
        title: 'Hubo un problema',
    },
    textoRequired: '*',
    helperText: {
        nifInteresado: 'Debe seguir el formato de NIF (8 números + letra) o NIE (letra + 7 números + letra)',
        nombreInteresado: 'Debe informar este campo',
        apellido1Interesado: 'Debe informar este campo',
        apellido2Interesado: 'Debe informar este campo',
        fechaNacimientoInteresado: 'El formato debe ser dd/mm/aaaa (Ej: 01/01/2020) y anterior a la fecha actual',
        emailInteresado: 'Debe seguir el formato mail@example.com',
        telefonoInteresado: 'Debe contener 9 dígitos comenzando por 8 o 9',
        telefonoMovilInteresado: 'Debe comenzar con el prefijo del país (incluyendo el símbolo +). Para España debe contener 9 dígitos comenzando por 6 o 7',
        entidadRazonSocialEntidadRepresentada: 'Debe informar el campo',
        cifEntidadRepresentada: 'Debe seguir el formato de CIF (letra + 8 números)',
        sexoInteresado: 'Debe informar el sexo',
        //Dirección genérica
        descripcionTipoViaDomicilioInteresado: 'Debe informar este campo',
        nombreDomicilioInteresado: 'Debe informar este campo',
        numeroDomicilioInteresado: 'Debe ser numérico',
        pisoDomicilioInteresado: 'Debe ser numérico',
        puertaDomicilioInteresado: 'N/A',
        letraDomicilioInteresado: 'N/A',
        escaleraDomicilioInteresado: 'N/A',
        nombreProvinciaDomicilioInteresado: 'Debe informar este campo',
        nombreMunicipioDomicilioInteresado: 'Debe informar este campo',
        codigoPostalDomicilioInteresado: 'Debe contener 5 dígitos y estar entre 01000 y 52999.',
        nombrePaisDomicilioInteresado: 'Debe informar este campo',
    },
    botones: {
        btnCancelar: 'CANCELAR',
        btnCrearCuenta: 'CREAR CUENTA',
        btnModificarCuenta: 'MODIFICAR CUENTA'
    },
    confirmacion: {
        titulo: '¿Confirma que desea Cancelar?',
        mensaje: 'Se perderán los datos introducidos hasta ahora'
    }
};

//////////////////////////////////////////////////////

export const properties = {
    RESOURCE_INTERESADO_ENTIDAD:'operacionesInteresado',
    URL_GET_INTERESADO_ENTIDAD: 'cargaPantallaInteresado',
    URL_POST_INTERESADO_ENTIDAD: 'guardarActualizarPantallaUsuario',
    RESOURCE_MANAGER :'manager',
    RESOURCE_MOTOR_TRAMITACION: 'api',
    RESOURCE_SALTO_BANDEJA:'logInBandeja',
    URL_GET_PAISES: 'lista-paises',
    URL_GET_PROVINCIAS: 'lista-provincias',
    URL_GET_MUNICIPIOS: 'lista-municipio/',
    URL_GET_TIPO_VIAS: 'lista-tipos-via',
    DATE_LENGTH: 10,
    URL_ORGANISMOS: '/find-by-ids-convocatoria',
};
/**
 * @constant attributesIdName contiene los atributos id y name
 * @param {*} text se inserta el texto para los atributos
 * Se crea para aprovechar que el atributo id y el name reciben el mismo nombre
 */
const attributesIdName = (text) => ({
    id: text,
    name: text,
});
/**
 * @constant attributesInputsDireccionGenerica
 * Constante que contiene los atributos necesarios para los inputs de la Dirección genérica.
 * Recibe por @param {*} textInteresado el texto para los atributos del interesado y para la entidad representada @param {*} textEnitdad
 * Dependiendo del valor de @param {*} condicion se insertan los atributos para la persona interesada o 
 * para la entidad representada.
 * @constant attributesSelecetsDireccionGenerica
 * Constante que contiene los atributos necesarios para los selects de la Dirección genérica.
 * La lógica es igual que la @constant attributesInputsDireccionGenerica
 */
const attributesInputsDireccionGenerica = (textInteresado, textEnitdad, maxLength, condicion) => ({
    ...(condicion ? { htmlFor: textInteresado } : { htmlFor: textEnitdad }),
    ...(condicion ? { ...attributesIdName(textInteresado) } : { ...attributesIdName(textEnitdad) }),
    ...(condicion ? { idGrid: 'grid' + textInteresado } : { idGrid: 'grid' + textEnitdad }),
    maxlength: maxLength,
});
const attributesSelecetsDireccionGenerica = (textInteresado, textEnitdad, maxLength, condicion) => ({
    ...(condicion ? { ...attributesIdName(textInteresado) } : { ...attributesIdName(textEnitdad) }),
    ...(condicion ? { nameInput: textInteresado } : { nameInput: textEnitdad }),
    maxlength: maxLength    
});
/**
 * @constant attributesValidation contiene las propiedades error y helperText.
 * Si la condición proporcionada por el parámetro value es false, se insertarán
 * los vamores de estas propiedades.
 * Con esta constante aplicamos si un campo no es válido.
 * @param {*} value recibe un valor boolean
 * @param {*} hlpTxt recibe el texto de la propiedad
 */
export const attributesValidation = (value, hlpTxt) => (
    !value && {
        error: true,
        helperText: hlpTxt,
    }
)
export const attributesValidationForm = (value, form)=> (
    !value && {
        error: true,
        FormHelperText: form,
    }
)

/**
 * Se crea la constante para insertar los atributos de los inputs
 * @constant attributesInputs contiene los atributos para los componentes inputs
 * @param {*} text recibe el texto a insertar a los atributos grid, id, name y htmlFor
 * @param {*} titlTextField recibe el título del inputLabel
 * @param {*} placeholder recibe el texto del placeholder
 */
const attributesInputs = (text, maxLength, title, txtRequired, required, placeholderTxt) => ({
    idGrid: 'grid' + text,
    ...attributesIdName(text),
    htmlFor: text,
    titlTextField: title,
    textRequired: txtRequired,
    isRequired: required,
    placeholder: placeholderTxt,
    type: 'text',
    maxlength: maxLength,
});

/**
 * @constant objAttDireccion contiene los atributos del componente direccionGenerica.
 * Para insertar los atributos se utiliza las constantes definidas anteirormente
 * @param {*} condicion Si la condicion es true se muestran los atributos del interesado,
 * si es false se muestran los atributos de la entidadRepresentada.
 */
export const objAttDireccion = (condicion) => ({
    //Inputs
    nombreDomicilio: {
        ...(attributesInputsDireccionGenerica('nombreDomicilioInteresado', 'nombreDomicilioEntidadRepresentada', '100', condicion)),
    },
    numeroDomicilio: {
        ...(attributesInputsDireccionGenerica('numeroDomicilioInteresado', 'numeroDomicilioEntidadRepresentada', '5', condicion)),
    },
    pisoDomicilio: {
        ...(attributesInputsDireccionGenerica('pisoDomicilioInteresado', 'pisoDomicilioEntidadRepresentada', '3', condicion)),
    },
    puertaDomicilio: {
        ...(attributesInputsDireccionGenerica('puertaDomicilioInteresado', 'puertaDomicilioEntidadRepresentada', '2', condicion)),
    },
    letraDomicilio: {
        ...(attributesInputsDireccionGenerica('letraDomicilioInteresado', 'letraDomicilioEntidadRepresentada', '2', condicion)),
    },
    escaleraDomicilio: {
        ...(attributesInputsDireccionGenerica('escaleraDomicilioInteresado', 'escaleraDomicilioEntidadRepresentada', '2', condicion)),
    },
    codigoPostalDomicilio: {
        ...(attributesInputsDireccionGenerica('codigoPostalDomicilioInteresado', 'codigoPostalDomicilioEntidadRepresentada', '5', condicion)),
    },
    //Selects
    descripcionTipoViaDomicilio: {
        ...(attributesSelecetsDireccionGenerica('tipoViaDomicilioInteresado', 'tipoViaDomicilioEntidadRepresentada', 'N/A', condicion)),
    },
    nombreProvinciaDomicilio: {
        ...(attributesSelecetsDireccionGenerica('provinciaDomicilioInteresado', 'provinciaDomicilioEntidadRepresentada', 'N/A', condicion)),
    },
    nombreMunicipioDomicilio: {
        ...(attributesSelecetsDireccionGenerica('municipioDomicilioInteresado', 'municipioDomicilioEntidadRepresentada', 'N/A', condicion)),
    },
    nombrePaisDomicilio: {
        ...(attributesSelecetsDireccionGenerica('paisDomicilioInteresado', 'paisDomicilioEntidadRepresentada', 'N/A', condicion)),
    },
});
/**
 * @constant objAttributes contiene un objeto con todos los atributos según etiqueta o componente,
 */
export const objAttributes = {
    //Containers
    containers: {
        //Container formularioAltaUsuario (Contenedor padre)
        formularioAltaUsuario: {
            id: 'containerFormAltaUsuario',
            component: 'div',
        }, componentes: {
            id: 'containerComponentes',
            component: 'div',
        },
    },
    grids: {
        encabezado: {
            id: 'gridEncabezado',
        },
        datosPersonales: {
            id: 'gridDatosPersonales',
        },
        botones: {
            id: 'gridBotones',
        },
    },

    //Títulos de encabezado
    titulos: {
        //Título de la página
        altaUsuario: {
            ...attributesIdName('altaUsuario'),
        },
        //Título datos personales
        datosPersonales: {
            ...attributesIdName('datosPersonales'),
        },
        datosEntidadRepresentada: {
            ...attributesIdName('entidadRepresentada'),
        },
        //Título dirección
        direccion: {
            ...attributesIdName('direccion'),
        },
    },
    //Parrafo de encabezado
    parrafo: {
        ...attributesIdName('txtAltaUsuario'),
    },
    //Alert
    alert: {
        severity: 'error',
        color: 'error',
        variant: 'outlined',
        icon: false,
    },
    //Formulario
    form: {
        ...attributesIdName('formAltaUsuario'),
    },
    //Inputs text, maxLength, title, txtRequired, required, placeholderTxt
    inputs: {
        //Entidad representada
        entidadRazonSocialEntidadRepresentada: {
            ...attributesInputs('entidadRazonSocialEntidadRepresentada', '50', 'Entidad representada o Razón social',' ', false, 'Entidad representada o Razón social'),
            disabled: true,
        },
        cifEntidadRepresentada: {
            ...attributesInputs('cifEntidadRepresentada', '15', 'CIF',' ', false,  'CIF'),
            disabled: true,
        },
        emailEntidad: {
            ...attributesInputs('emailEntidadRepresentada', '64', 'Correo electrónico', '', false, 'Correo electrónico'),
        },
        telefonoEntidad: {
            ...attributesInputs('telefonoEntidadRepresentada', '9', 'Teléfono', '', false, 'Teléfono'),
        },
        telefonoMovilEntidadInteresado: {
            ...attributesInputs('telefonoMovilEntidadRepresentada', '9', 'Teléfono móvil', '', false, 'Teléfono móvil'),
        },
        //Datos Personales
        nifInteresado: {
            ...attributesInputs('nifInteresadoRepresentada', '15', 'NIF / NIE', objText.textoRequired, true,  'NIF / NIE'),
            disabled: true,
        },
        nombreInteresado: {
            ...attributesInputs('nombreInteresado', '100', 'Nombre', objText.textoRequired, true, 'Nombre'),
            disabled: true,
        },
        apellido1Interesado: {
            ...attributesInputs('apellido1Interesado', '50', 'Primer apellido', objText.textoRequired, true, 'Primer apellido'),
            disabled: true,
        },
        apellido2Interesado: {
            ...attributesInputs('apellido2Interesado', '50', 'Segundo apellido', '', false, 'Segundo apellido'),
            disabled: true,
        },
        fechaNacimientoInteresado: {
            ...attributesInputs('fechaNacimientoInteresado', '10', 'Fecha de nacimiento', objText.textoRequired, true, 'Fecha de nacimiento'),
            type: 'date',
        },
        emailInteresado: {
            ...attributesInputs('emailInteresado', '64', 'Correo electrónico', '', false, 'Correo electrónico'),
        },
        telefonoInteresado: {
            ...attributesInputs('telefonoInteresado', '9', 'Teléfono', '', false, 'Teléfono'),
        },
        telefonoMovilInteresadoInteresado: {
            ...attributesInputs('telefonoMovilInteresado', '17', 'Teléfono móvil', '', false, 'Teléfono móvil'),
        },
    },
    //RadioButton
    sexoInteresado: {
        //Grid
        idGrid: 'gridSexo',
        //FormControl
        componentFormControl: 'div',
        title: 'Sexo',
        isRequired: true,
        textRequired: objText.textoRequired,
        //FormLabel
        componentFormLabel: 'label',
        ariaLabel: 'sexoInteresado',
        ...attributesIdName('sexoInteresado'),
        maxLength: 'N/A',
        //RadioGroup
        id: 'sexoInteresado',
        name: 'sexoInteresado',
    },
    //Texto estático
    proteccionDatos: {
        //Grid
        idGrid: 'gridProteccionDatos',
        //Parrafo
        ...attributesIdName('proteccionDatos'),
    },
    //Botones
    btnCrearCuenta: {
        ...attributesIdName('botonCrearUsuario'),
        type: 'submit',
    },
    btnCancelar: {
        ...attributesIdName('botonCancelar'),
        type: 'submit',
    },
}
//Variable que contiene los valores para el paginador
const pageable = '?page=0&size=1000';

//Contiene las propiedades necesarias para los endPoints
export const propertiesPCT3 = {
    resource: {
        paises: 'pais',
        provincias: 'provincia',
        municipios: 'municipio',
        tipoVia: 'tipoVia',
        interesdado: 'interesado',
        tipoInteresado: 'tipo-interesado' 
    },
    url: {
        provincia: '/provincia/',
        interesadoDatosContactoPorDefecto: '/obtenerDatosInteresadoPorDefecto',
        guardarActualizarInteresado: '/insertarActualizarInteresadoOV3'
    },
    pageable: {
        paises: `${pageable}&sort=descripcionCorta,ASC`,
        provincias: `${pageable}&size=1000&sort=nombre,ASC`,
        municipios: `${pageable}&sort=descripcion,ASC`,
        tipoVia: `${pageable}&sort=descripcion,ASC`
    },
    dataFrom: {
        pct3: 'PCT3',
        pct2: 'PCT2'
    }
};
const datosInteresado1 = {
    interesado: {
        id: '',
        nombre: '',
        apellido1: '',
        apellido2: '',
        tipoIdentificador: 'DNI',
        identificador: '',
        sexo: '',
        fechaNacimiento: '',
        datosContactoPorDefecto: {}
    },
    datosContacto: {
        id: '',
        idDatoExpediente: null,
        interesado: {},
        tipoInteresado: {},
        tipoNotificacion: {},
        tipoVia: {},
        nombreVia: '',
        numero: '',
        letra: '',
        escalera: '',
        piso: '',
        puerta: '',
        postal: '',
        telefono: '',
        telefonoMovil: '',
        fax: '',
        email: '',
        idPais: '',
        pais: {},
        provincia: {},
        municipio: {},
        idProvincia: '',
        idMunicipio: '',  
        region: '',
        ciudad: '',
        fechaBaja: '',
        isNotificacion: ''
    }
}

const datosInteresado2 = {
    interesado: {
        id: '',
        nombre: '',
        apellido1: null,
        apellido2: null,
        tipoIdentificador: 'CIF',
        identificador: '',
        sexo: null,
        fechaNacimiento: null,
        datosContactoPorDefecto: {}
    },
    datosContacto: {
        id: '',
        idDatoExpediente: null,
        interesado: {},
        tipoInteresado: {},
        tipoNotificacion: {},
        tipoVia: {},
        nombreVia: '',
        numero: '',
        letra: '',
        escalera: '',
        piso: '',
        puerta: '',
        postal: '',
        telefono: '',
        telefonoMovil: '',
        fax: '',
        email: '',
        idPais: '',
        pais: {},
        provincia: {},
        municipio: {},
        idProvincia: '',
        idMunicipio: '',  
        region: '',
        ciudad: '',
        fechaBaja: '',
        isNotificacion: ''
    }
}

export const objInteresadoPCT3 = {
    interesado1: {...datosInteresado1},
    interesado2: {...datosInteresado2}
};